import { render, staticRenderFns } from "./EmptyResultsMessage.vue?vue&type=template&id=3a2348e0&scoped=true"
import script from "./EmptyResultsMessage.vue?vue&type=script&lang=js"
export * from "./EmptyResultsMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2348e0",
  null
  
)

export default component.exports